import api from '../../api/axiosInstance';
import { APP_SETTINGS } from "../../../../config";
import { getFilteredQuery } from "app/assets/genericActions";
const getAuthHeaders = (token) => {
    if (!token) {
        console.error("Token is missing for API request.");
        return {};
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};


export const getHolidays = (filters, token) => {
    return api.get(`${APP_SETTINGS.API_PATH.HOLIDAYS.get}?${getFilteredQuery(
        filters
    )}`, getAuthHeaders(token));
};

export const getHolidayById = (id, token) => {
    return api.get(`${APP_SETTINGS.API_PATH.HOLIDAYS.getBYId}/${id}`, getAuthHeaders(token));
};

export const updateHoliday = (id, data, token) => {
    return api.patch(`${APP_SETTINGS.API_PATH.HOLIDAYS.update}/${id}`, data, getAuthHeaders(token));
};

export const deleteHoliday = (id, token) => {
    return api.delete(`${APP_SETTINGS.API_PATH.HOLIDAYS.delete}/${id}`, getAuthHeaders(token));
};

export const addHoliday = (data, token) => {
    return api.post(`${APP_SETTINGS.API_PATH.HOLIDAYS.add}`, data, getAuthHeaders(token));
};